export const PUBLISH_MESSAGE = {
  STARTED: 'PUBLISH_MESSAGE_STARTED',
  SUCCEEDED: 'PUBLISH_MESSAGE_SUCCEEDED',
  FAILED: 'PUBLISH_MESSAGE_FAILED'
};